module.exports = __webpack_public_path__ + "img/tangka02.088f7452.png";